import React, { useEffect, useState } from "react";

/** Использует Instagram Graph API (Basic Display). В .env добавь:
 * REACT_APP_IG_TOKEN=YOUR_LONG_LIVED_TOKEN
 */
export default function InstagramFeed({ limit = 9 }) {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    const token = process.env.REACT_APP_IG_TOKEN;
    if (!token) { setErr("Nav IG token (REACT_APP_IG_TOKEN)."); return; }
    const url = `https://graph.instagram.com/me/media?fields=id,media_url,permalink,thumbnail_url,media_type,caption&access_token=${token}`;
    fetch(url)
      .then(r => r.json())
      .then(d => {
        if (d.error) throw new Error(d.error.message || "IG error");
        setItems((d.data || []).slice(0, limit));
      })
      .catch(e => setErr(e.message || "IG fetch error"));
  }, [limit]);

  if (err) return <div className="ig__error">Instagram feed nav pieejams: {err}</div>;

  return (
    <div className="ig">
      {items.map(m => (
        <a key={m.id} href={m.permalink} target="_blank" rel="noreferrer" aria-label="Instagram">
          {m.media_type === "VIDEO"
            ? <video src={m.media_url} muted playsInline preload="metadata" />
            : <img src={m.media_url} alt={m.caption || "Instagram"} loading="lazy" />}
        </a>
      ))}
    </div>
  );
}
